import { render, staticRenderFns } from "./IntegrationsSettings.vue?vue&type=template&id=4fbcac17&scoped=true"
import script from "./IntegrationsSettings.vue?vue&type=script&lang=js"
export * from "./IntegrationsSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbcac17",
  null
  
)

export default component.exports